import { useNavigate } from 'react-router-dom';
import { BENTO_CTA } from './data';

export default function BentoCtaCard() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate('/solicitar-demo')}
      className="group relative flex min-h-[280px] cursor-pointer flex-col overflow-hidden rounded-3xl text-left"
    >
      <img
        src={BENTO_CTA.image}
        alt="Participante comemorando a conquista de pontos no aplicativo"
        className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>

      <div className="relative z-10 flex h-full flex-col justify-between gap-5 p-5 md:p-6">
        <div className="flex justify-end">
          <div className="flex items-center gap-3 rounded-2xl bg-background-50 px-4 py-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-check-line text-base"></i>
            </span>
            <div className="leading-tight">
              <p className="font-heading text-sm font-bold text-foreground-950">{BENTO_CTA.badgeTitle}</p>
              <p className="text-xs text-foreground-600">{BENTO_CTA.badgeText}</p>
            </div>
          </div>
        </div>

        <div className="flex items-end justify-between gap-3">
          <span className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors group-hover:bg-primary-600">
            {BENTO_CTA.button}
            <i className="ri-arrow-right-line"></i>
          </span>
          <span className="hidden max-w-[42%] text-right font-hand text-2xl leading-none text-background-50 drop-shadow-[0_2px_6px_rgba(0,0,0,0.55)] sm:block md:text-3xl">
            {BENTO_CTA.script}
          </span>
        </div>
      </div>
    </button>
  );
}